import React from "react";

export const SaveOutfitDialog = ({
  open,
  outfitName,
  setOutfitName,
  publish,
  setPublish,
  savingOutfit,
  onSubmit,
  onClose,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4" onClick={onClose}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={onSubmit} className="bg-[#F6F5F1] border border-black/10 max-w-md w-full p-8 md:p-10 relative">
        <div className="font-mono-eyebrow">Archive this look</div>
        <h3 className="font-serif-display text-4xl leading-none mt-2 mb-8">Name & publish</h3>
        <div>
          <label className="font-mono-eyebrow">Outfit name</label>
          <input
            data-testid="save-outfit-name"
            autoFocus
            value={outfitName}
            onChange={(e) => setOutfitName(e.target.value)}
            className="field mt-2"
          />
        </div>
        <label className="mt-8 flex items-start gap-3 cursor-pointer group">
          <input
            data-testid="save-outfit-public"
            type="checkbox"
            checked={publish}
            onChange={(e) => setPublish(e.target.checked)}
            className="mt-1 w-4 h-4 accent-black"
          />
          <div>
            <div className="font-mono-eyebrow">Publish to Discover feed</div>
            <div className="text-black/60 text-sm mt-1 leading-relaxed">
              Share this look on the public runway. Portraits stay private — only the try-on is shown, alongside live buy-now retailer URLs.
            </div>
          </div>
        </label>
        <div className="flex justify-end gap-3 mt-10 pt-6 border-t border-black/10">
          <button type="button" onClick={onClose} className="btn-outline-ink">Cancel</button>
          <button data-testid="save-outfit-confirm" type="submit" disabled={savingOutfit} className="btn-ink disabled:opacity-50">
            {savingOutfit ? "Saving…" : (publish ? "Publish" : "Save")}
          </button>
        </div>
      </form>
    </div>
  );
};
